function ServidorIndisponivel() {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center">
        <h2>A conexão com o servidor falhou!</h2>
      </div>
    </div>
  );
}

export default ServidorIndisponivel;
